








// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import LineChart from './LineChart.js'
import Vue, { PropType } from 'vue'
import { ChartData, ChartOptions } from 'chart.js'

export default Vue.extend({
  components: {
    LineChart,
  },
  props: {
    data: Object as PropType<ChartData>,
  },
  data() {
    return {
      datacollection: null as null | ChartData,
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMin: 0,
              },
            },
          ],
        },
        title: {
          text: this.$t('topup.reports'),
          display: true,
        },
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0,
          },
          point: {
            hoverRadius: 10,
            hitRadius: 10,
          },
        },
      } as ChartOptions,
    }
  },
  mounted() {
    this.fillData()
  },
  methods: {
    fillData() {
      this.datacollection = this.data
    },
    getRandomInt() {
      return (Math.floor(Math.random() * (500 - 50 + 10)) + 50) * 30
    },
  },
  watch: {
    data: {
      handler() {
        this.fillData()
      },
      deep: true,
    },
  },
})
